import { render, staticRenderFns } from "./by-role.vue?vue&type=template&id=4c35e29f"
import script from "./by-role.vue?vue&type=script&lang=js"
export * from "./by-role.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SuccessStoryLink: require('/home/runner/work/marketing/marketing/components/SuccessStoryLink.vue').default,LargeAccordion: require('/home/runner/work/marketing/marketing/components/LargeAccordion.vue').default})
